/*
* @Author: 朱亚
* @Date: 2020-10-10 10:19:09
* @说明：主程序
*/
import Vue from 'vue'
import api from './api/index'
import App from './App'
import router from './router'
import store from './store'

import formatMoney from './plugins/formatMoney'
import formValidate from './plugins/formValidate'
import WebUploader from './plugins/initWebUploader'
import showToast from './plugins/showToast'
import scrollPlugin from './plugins/willScrollToBottom'
import isWxBrowser from './plugins/isWxBrowser'
import shareUtil from './plugins/shareUtil'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


import './plugins/input.js'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

require('./plugins/utility.js')
if (process.env.NODE_ENV === 'development' && process.env.PROXY_MOCK) {
console.log('*** NODE_ENV:' + process.env.NODE_ENV + ', process.env.PROXY_MOCK:' + process.env.PROXY_MOCK + '***')

require('./mock/index.js')
}

Vue.use(ElementUI)
Vue.use(ToastPlugin, { time: 3000, width: 'auto' })
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)


Vue.use(api)


Vue.use(formatMoney)


Vue.use(formValidate)


Vue.use(WebUploader)


Vue.use(showToast)


Vue.use(scrollPlugin)


Vue.use(isWxBrowser)


Vue.use(shareUtil)

Vue.$vux.loading.hide()


localStorage.themeColor = '#e53e28'
window._HOST = ''

if (localStorage.host !== undefined) {
window._HOST = localStorage.host
}


let routerFiles = [{'1': 'home'}, {'2': 'order'}, {'3': 'customer'}, {'4': 'system'}]

router.beforeEach((to, from, next) => {

if (to.query.host && to.query.host !== 'undefined') {

if (localStorage.host !== undefined && to.query.host !== localStorage.host) {
delete localStorage.access_token
}
localStorage.host = to.query.host
window._HOST = localStorage.host
}

if (to.query.access_token && to.query.access_token !== 'undefined') localStorage.access_token = to.query.access_token

if (to.query.login_store_id && to.query.login_store_id !== 'undefined') localStorage.login_store_id = to.query.login_store_id

if (to.query.auth_id && to.query.auth_id !== 'undefined') localStorage.auth_id = to.query.auth_id



const module = to.path.split('/')[1] 
store.dispatch('CHANGE_NAV_MODULE', module)

if (module === 'wxwork') {
routerFiles = [{'1': 'customer'}, {'2': 'order'}, {'3': 'sales'}, {'4': 'resource'}, {'5': 'coupon'}]
}
Vue.prototype.$module = module


let token = localStorage.access_token
let notNeedAuth = to.meta && to.meta.notNeedAuth
if (!notNeedAuth && (token === undefined || !token)) {
if (module !== 'wxwork') {
alert('请先登录 ' + to.path + '=>' + from.path)
next('/isBind?host=' + localStorage.host)
return false
}
}

let navTabIndex = 0
routerFiles.map((item, index) => {
for (let _key in item) {
let routerPrefix = item[_key] + '_'
if (to.path.includes(routerPrefix)) navTabIndex = Number(_key)
}
})
if (to.path.toLowerCase().includes('store_shopcart')) {
store.dispatch('CHANGE_NAV_INDEX', 2)
} else {
store.dispatch('CHANGE_NAV_INDEX', navTabIndex)
}

next()
})

window._isPhone = /^[1][3,4,5,7,8,9][0-9]{9}$/ 

Vue.config.productionTip = false

/* eslint-disable no-new */

window.app = new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js